export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7738.39b3cd0f.jpg";